import { createApi } from "@reduxjs/toolkit/query/react";

import apiConfig from "configs/apiConfig";
import { REDUCER_PATHS } from "store/config";

import { customFetchBase } from ".";

const dashboardApi = createApi({
  reducerPath: REDUCER_PATHS.DASHBOARD,
  baseQuery: customFetchBase,
  endpoints: (builder) => ({
    superAdminDashboard: builder.mutation({
      query: (data) => ({
        url: apiConfig.SUPER_ADMIN_DASHBOARD,
        method: "POST",
        body: data,
      }),
    }),
    clubAdminDashboard: builder.mutation({
      query: (data) => ({
        url: apiConfig.CLUB_ADMIN_DASHBOARD,
        method: "POST",
        body: data,
      }),
    }),
    brandAdminDashboard: builder.mutation({
      query: (data) => ({
        url: apiConfig.BRAND_ADMIN_DASHBOARD,
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useSuperAdminDashboardMutation,
  useClubAdminDashboardMutation,
  useBrandAdminDashboardMutation,
} = dashboardApi;

export default dashboardApi;
